import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Notes from "@/pages/Notes";
import Activities from "@/pages/Activities";
import FollowUps from "@/pages/FollowUps";
import Tasks from "@/pages/Tasks";
import Partners from "@/pages/Partners";
import Leads from "@/pages/Leads";
import Quotes from "@/pages/Quotes";
import Challenges from "@/pages/Challenges";
import WeeklyPlanning from "@/pages/WeeklyPlanning";
import WeeklyReview from "@/pages/WeeklyReview";
import MyDay from "@/pages/MyDay";

import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  // Synchronous OAuth callback check (URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout><Dashboard /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/companies"
        element={
          <ProtectedRoute>
            <Layout><Companies /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/companies/:companyId"
        element={
          <ProtectedRoute>
            <Layout><CompanyDetail /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/contacts"
        element={
          <ProtectedRoute>
            <Layout><Contacts /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/contacts/:contactId"
        element={
          <ProtectedRoute>
            <Layout><ContactDetail /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/challenges"
        element={
          <ProtectedRoute>
            <Layout><Challenges /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/weekly-planning"
        element={
          <ProtectedRoute>
            <Layout><WeeklyPlanning /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/weekly-review"
        element={
          <ProtectedRoute>
            <Layout><WeeklyReview /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-day"
        element={
          <ProtectedRoute>
            <Layout><MyDay /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/notes"
        element={
          <ProtectedRoute>
            <Layout><Notes /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/activities"
        element={
          <ProtectedRoute>
            <Layout><Activities /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/followups"
        element={
          <ProtectedRoute>
            <Layout><FollowUps /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <ProtectedRoute>
            <Layout><Tasks /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners"
        element={
          <ProtectedRoute>
            <Layout><Partners /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads"
        element={
          <ProtectedRoute>
            <Layout><Leads /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/quotes"
        element={
          <ProtectedRoute>
            <Layout><Quotes /></Layout>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
